import { AD_TRACK_SUCCESS, AD_TRACK_FAIL } from "../actions/ActionConstant";

const initialState = {
  tracked: false,
};

export default function AdReducer(state = initialState, action) {
  switch (action.type) {
    case AD_TRACK_SUCCESS:
      return { ...state, tracked: true };

    case AD_TRACK_FAIL:
      return state;

    default:
      return state;
  }
}
